import { OcapiError } from '../../../../types/ocapi-error';
import { getResponseErrorCode } from '../../../../utils/get-response-error-code';
/**
 * API errors for resetting a member's password.
 */
export var ResetMemberPasswordErrorCodeV1;
(function (ResetMemberPasswordErrorCodeV1) {
    /**
     * Password exceeds the value for maximum password length.
     */
    ResetMemberPasswordErrorCodeV1[ResetMemberPasswordErrorCodeV1["PasswordMaximumLengthExceeded"] = 33000] = "PasswordMaximumLengthExceeded";
    /**
     * Password doesn't meet the requirements for minimum password length.
     */
    ResetMemberPasswordErrorCodeV1[ResetMemberPasswordErrorCodeV1["PasswordMinimumLengthNotMet"] = 33001] = "PasswordMinimumLengthNotMet";
    /**
     * Password doesn't meet the requirements for minimum number of included numeric characters.
     */
    ResetMemberPasswordErrorCodeV1[ResetMemberPasswordErrorCodeV1["PasswordMinimumNumericCharactersNotMet"] = 33002] = "PasswordMinimumNumericCharactersNotMet";
    /**
     * Password doesn't meet the requirements for minimum number of included non-numeric characters.
     */
    ResetMemberPasswordErrorCodeV1[ResetMemberPasswordErrorCodeV1["PasswordMinimumNonNumericCharactersNotMet"] = 33003] = "PasswordMinimumNonNumericCharactersNotMet";
    /**
     * Password doesn't meet the requirements for minimum number of included distinct characters.
     */
    ResetMemberPasswordErrorCodeV1[ResetMemberPasswordErrorCodeV1["PasswordMinimumDistinctCharactersNotMet"] = 33004] = "PasswordMinimumDistinctCharactersNotMet";
    /**
     * Password contains the user's email address.
     */
    ResetMemberPasswordErrorCodeV1[ResetMemberPasswordErrorCodeV1["PasswordContainsEmail"] = 33005] = "PasswordContainsEmail";
    /**
     * Password contains the username.
     */
    ResetMemberPasswordErrorCodeV1[ResetMemberPasswordErrorCodeV1["PasswordContainsUsername"] = 33006] = "PasswordContainsUsername";
    /**
     * Password contains the user's given name or surname.
     */
    ResetMemberPasswordErrorCodeV1[ResetMemberPasswordErrorCodeV1["PasswordContainsGivenOrSurname"] = 33007] = "PasswordContainsGivenOrSurname";
    /**
     * Password is a known compromised password.
     */
    ResetMemberPasswordErrorCodeV1[ResetMemberPasswordErrorCodeV1["PasswordKnownCompromised"] = 33008] = "PasswordKnownCompromised";
    /**
     * Password contains disallowed words.
     */
    ResetMemberPasswordErrorCodeV1[ResetMemberPasswordErrorCodeV1["PasswordContainsDisallowedWords"] = 33009] = "PasswordContainsDisallowedWords";
    /**
     * Password reset code is invalid.
     */
    ResetMemberPasswordErrorCodeV1[ResetMemberPasswordErrorCodeV1["PasswordResetCodeInvalid"] = 33011] = "PasswordResetCodeInvalid";
})(ResetMemberPasswordErrorCodeV1 || (ResetMemberPasswordErrorCodeV1 = {}));
export class ResetMemberPasswordErrorV1 extends OcapiError {
    constructor(errorCode) {
        const message = `Failed to reset member's password. API error code ${errorCode}: ${ResetMemberPasswordErrorCodeV1[errorCode]}`;
        super(errorCode, message);
    }
}
export async function getResetMemberPasswordErrorV1(error) {
    const errorCode = await getResponseErrorCode(error);
    return errorCode && Object.values(ResetMemberPasswordErrorCodeV1).includes(errorCode)
        ? new ResetMemberPasswordErrorV1(errorCode)
        : error;
}
//# sourceMappingURL=reset-member-password-error.js.map